// extracted by mini-css-extract-plugin
module.exports = {"Picture":"Picture_Picture__mj4Ql","isFallback":"Picture_isFallback__bQOh4","Picture_asset":"Picture_Picture_asset__Ved9S","Picture___cover":"Picture_Picture___cover__o_dp9"};